<div class="container-fluid sinalization-detail">

    <div class="row">
        <div class="col-12 d-flex align-items-center">
            <a routerLink="/signalings" id="signalings-link">
                <i class="icon-edponline-Bra-073 rotate-90 font-size-24 color-black"></i>
            </a>
        </div>
        <div class="col-12 d-flex justify-content-center fast-quote-title mt-4">
            <span>{{'edp.emarket.fast.quote' | translate}}</span>
        </div>
        <div class="col-12 d-flex justify-content-center fast-quote-subtitle mt-2" [ngClass]="{'hidden': sinalization.mns === 'fastQuoteOTC'}">
            <span>{{'edp.emarket.sinalization.detail.price.target' | translate}}</span>
        </div>
    </div>

    <div class="row line mt-4"></div>

    <div class="row mt-3">
        <div class="col-12 px-4 d-flex justify-content-end">
            <span class="mat-val-label text-lowercase">{{'edp.emarket.sinalization.detail.as' | translate}} {{ sinalization.sdt }}</span>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6 pl-4">
            <label class="mat-val-label d-block">
              {{'edp.emarket.fast.quote.maturidade' | translate}}
            </label>
            <span>{{ sinalization.mmt }}</span>
        </div>
        <div class="col-6">
            <label class="mat-val-label d-block">
              {{'edp.emarket.fast.quote.valor' | translate}}
            </label>
            <span>{{ sinalization.mtv }}%</span>
        </div>
    </div>

    <div class="row mt-4" [ngClass]="{'hidden': sinalization.mcv === 0}">
        <div class="col-12 pl-4">
            <label class="mat-val-label d-block">
              {{'edp.emarket.price.preco' | translate}}
            </label>
            <span>{{ sinalization.mcv }}</span>
        </div>
    </div>

</div>
